<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <div *ngIf="currentUser">
    <table class="table" style="background-color:white;">
      <tr>
        <td style="background-color:#0f2b46;color:white;" colspan="2"> Upload Corporate/Company Document </td>
        <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
      </tr>
    </table>



    <form (ngSubmit)="upload()">

      <div class="col-lg-12 mt-2">
        <div class="row">
          <div class="col-lg-4">
            <label for="" class="font-weight-bold ">
              Corporate/Company Logo (*.png, *.jpg, *.jpeg)
            </label>
            <div class="img-height" *ngIf="imgURLlogo">
              <img [src]="imgURLlogo" />
            </div>
            <div id="" *ngIf="btn == 0 || btn == 4">
              <div class="custom-file  mt-2">
                <input type="file" class="custom-file-input" id="customFile" #file2 accept='image/png, image/jpg, image/jpeg'
                       (change)="preview(file2.files,1)" />
                <label class="custom-file-label" for="customFile">Choose file</label>
              </div>
              <mat-error *ngIf="!logoImage">
                {{msg1}}
              </mat-error>
            </div>
          </div>
          <div class="col-lg-4">
            <label for="" class="font-weight-bold ">
              Memorandum Articles Of Association (PDF Only)
            </label>
            <div *ngIf="imgMemorandumname">
              {{imgMemorandumname}}

            </div>
            <div *ngIf="imgMemorandumurl">
              <a href="{{imgMemorandumurl}}" target="_blank">Uploaded Pdf</a>

            </div>
            <div id="" *ngIf="btn == 0 || btn == 4">
              <div class="custom-file  mt-2">
                <input type="file" class="custom-file-input" id="customFile" #memorandum accept='application/pdf'
                       (change)="previewpdf(memorandum.files,5)" />
                <label class="custom-file-label" for="customFile">Choose file</label>
              </div>
              <mat-error *ngIf="!logoMemorandum">
                {{msgMemorandum}}
              </mat-error>
            </div>
          </div>
          <div class="col-lg-4">
            <label for="" class="font-weight-bold ">
              Certificate Of Incorporation (PDF Only)
            </label>
            <!--<div class="img-height" *ngIf="imgCertificate">
    <img [src]="imgCertificate" />
  </div>-->
            <div *ngIf="imgCertificatename">
              {{imgCertificatename}}

            </div>

            <div *ngIf="imgCertificateurl">
              <a href="{{imgCertificateurl}}" target="_blank">Uploaded Pdf</a>

            </div>
            <div id="" *ngIf="btn == 0 || btn == 4">
              <div class="custom-file  mt-2">
                <input type="file" class="custom-file-input" id="customFile" #certificate accept='application/pdf'
                       (change)="previewpdf(certificate.files,6)" />
                <label class="custom-file-label" for="customFile">Choose file </label>
              </div>
              <mat-error *ngIf="!logoCertificate">
                {{msgCertificate}}
              </mat-error>
            </div>
          </div>
        </div>
      </div>
      &nbsp;


      <div class="col-lg-12 mt-2">
        <div class="row">
          <div class="col-lg-4 pb-3">
            <h6>Address Proof Documents (Select Upto 6 images for upload in png, jpg, jpeg) </h6>
          </div>
          <div class="col-lg-4 pb-3">

            <div class="custom-file" *ngIf="btn == 0 || btn == 4">
              <input type="file" class="custom-file-input" id="addrsFile" #addrsFile accept='image/png, image/jpg, image/jpeg'
                     (change)="preview(addrsFile.files,2)">
              <label class="custom-file-label" for="addrsFile">Choose file</label>
            </div>
            <mat-error *ngIf="!imgURLaddrsFile">
              {{msg2}}
            </mat-error>

          </div>
        </div>

        <div class="card px-3 py-3">
          <div class="row">

            <div class="col-lg-4 pb-3" *ngFor="let d of addrsDocList;let i=index">
              <div class="img-height">
                <i class="fa fa-close" (click)="closeModal1(i)" *ngIf="btn == 0 || btn == 4"></i>
                <img class="w-100" [src]="d" />
              </div>
            </div>
          </div>

        </div>
        <hr>
      </div>

      <div class="col-lg-12 mt-2">
        <div class="row">
          <div class="col-lg-4 pb-3">
            <h6>
              ID Copies of Directors & Shareholders (Select Upto 6 images for upload in png, jpg, jpeg)
            </h6>
          </div>
          <div class="col-lg-4 pb-3" *ngIf="btn == 0 || btn == 4">

            <div class="custom-file">
              <input type="file" class="custom-file-input" id="shareholdersID" #shareholdersID
                     accept='image/png, image/jpg, image/jpeg' (change)="preview(shareholdersID.files,3)">
              <label class="custom-file-label" for="shareholdersID">Choose file</label>
            </div>
            <mat-error *ngIf="!imgURLshareholdersID">
              {{msg3}}
            </mat-error>

          </div>
        </div>

        <div class="card px-3 py-3">
          <div class="row">

            <div class="col-lg-4 pb-3" *ngFor="let d of shareholdersIDList;let i=index">
              <div class="img-height">
                <i class="fa fa-close" (click)="closeModal2(i)" *ngIf="btn == 0 || btn == 4"></i>
                <img class="w-100" [src]="d" />
              </div>
            </div>
          </div>

        </div>
        <hr>
      </div>

      <div class="col-lg-12 mt-2">
        <div class="row">
          <div class="col-lg-4 pb-3">
            <h6>Pictures of Shareholders/Directors (Select Upto 6 images for upload in png, jpg, jpeg)</h6>
          </div>
          <div class="col-lg-4 pb-3" *ngIf="btn == 0 || btn == 4">

            <div class="custom-file">

              <input type="file" class="custom-file-input " id="shareholdersImage" #shareholdersImage
                     accept='image/png, image/jpg, image/jpeg' (change)="preview(shareholdersImage.files,4)">
              <label class="custom-file-label" for="shareholdersImage">Choose file</label>
            </div>
            <mat-error *ngIf="!imgURLshareholdersPicture">
              {{msg4}}
            </mat-error>

          </div>
        </div>

        <div class="card px-3 py-3">
          <div class="row">

            <div class="col-lg-4 pb-3" *ngFor="let d of shareholdersPicturesList;let i=index">
              <div class="img-height">
                <i class="fa fa-close" (click)="closeModal3(i)" *ngIf="btn == 0 || btn == 4"></i>
                <img class="w-100" [src]="d" />
              </div>
            </div>
          </div>

        </div>
      </div>

      <div style="padding-top:10px;text-align:center;" class="col-lg-12 mt-2">
        <button type="submit" mat-raised-button color="primary" *ngIf="btn == 0 || btn == 4" class="login-btn">
          Save
        </button>
      </div>

    </form>
  </div>
</fieldset>

